import { post, put, del, get, patch } from 'aws-amplify/api';
import { processResponse } from './api_util';
import useSWR from 'swr'

const PERIOD_ACTION_REMOVE = 'remove';
const PERIOD_ACTION_RESTORE = 'restore';

const updateScannedBankStatement = async (scanId, accountPk, periodPk, periodAction) => {
    console.log('updateScannedBankStatement')
    console.log(`scanId: ${scanId}`)
    console.log(`accountPk: ${accountPk}`)
    console.log(`periodPk: ${periodPk}`)
    console.log(`periodAction: ${periodAction}`)

    const payload = {
        apiName: 'LivisiblyOcrolusScanApi',
        path: `scans/bank_accounts/bank_statements`,
        options: {
            body: {
                period_action: periodAction,
                scan_id: scanId,
                bank_account_pk: accountPk,
                period_pk: periodPk
            }
        }
    }
    console.log(`posting payload: ${JSON.stringify(payload)}`)
    const restOperation = post(payload);


    const response = await restOperation.response;
    return processResponse(response)
};

export const removeScannedBankStatement = async (scanId, accountPk, periodPk) => {
    return updateScannedBankStatement(scanId, accountPk, periodPk, PERIOD_ACTION_REMOVE);
};
export const restoreScannedBankStatement = async (scanId, accountPk, periodPk) => {
    return updateScannedBankStatement(scanId, accountPk, periodPk, PERIOD_ACTION_RESTORE);
};

// Current-pipeline statement removal (uses UUID statement_id instead of pk fields)
const updateStatement = async (scanId, statementId, periodAction) => {
    const payload = {
        apiName: 'LivisiblyOcrolusScanApi',
        path: `scans/bank_accounts/bank_statements`,
        options: {
            body: {
                period_action: periodAction,
                scan_id: scanId,
                statement_id: statementId
            }
        }
    };
    const restOperation = post(payload);
    const response = await restOperation.response;
    return processResponse(response);
};

export const removeStatement = async (scanId, statementId) => {
    return updateStatement(scanId, statementId, PERIOD_ACTION_REMOVE);
};
export const restoreStatement = async (scanId, statementId) => {
    return updateStatement(scanId, statementId, PERIOD_ACTION_RESTORE);
};

// Super-admin document re-issue: invalidate the document's existing published
// statement(s) and push a fresh scan through the current pipeline. The caseID
// and super-admin gating are resolved server-side from the authenticated user,
// so the client only sends the documentID.
const PERIOD_ACTION_REISSUE = 'reissue';

export const reissueDocument = async (documentId) => {
    const payload = {
        apiName: 'LivisiblyOcrolusScanApi',
        path: `scans/bank_accounts/bank_statements`,
        options: {
            body: {
                period_action: PERIOD_ACTION_REISSUE,
                documentID: documentId
            }
        }
    };
    const restOperation = post(payload);
    const response = await restOperation.response;
    return processResponse(response);
};